import axios from "axios";
import cleanParams from "utils/cleanParams";
import { getLocalStorage } from "utils/localStorageUtils";

const baseURL = import.meta.env.VITE_APP_BASE_URL;
const misbarBaseUrl = import.meta.env.VITE_APP_MISBAR_BASE_URL;

export const axiosInstance = axios.create({
  baseURL,
});
export const axiosInstanceV2 = axios.create({
  baseURL,
});
export const axiosAdminInstance = axios.create({
  baseURL,
});
export const misbarAdminInstance = axios.create({
  baseURL: misbarBaseUrl,
});
export const misbarInstance = axios.create({
  baseURL: misbarBaseUrl,
});
export const misbarInstanceV2 = axios.create({
  baseURL: misbarBaseUrl,
});
export const misbarInstanceV3 = axios.create({
  baseURL: misbarBaseUrl,
});
export const misbarInstanceV4 = axios.create({
  baseURL: misbarBaseUrl,
});

axiosAdminInstance.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_admin_token")}`,
        "Api-Key": import.meta.env.VITE_APP_NOTIFICATIONS_API_KEY,
        ...config.headers,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
misbarAdminInstance.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_admin_token")}`,
        ...config.headers,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_user_token")}`,
        ...config.headers,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstanceV2.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_user_token")}`,
        ...config.headers,
        "X-Version": 2,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
misbarInstance.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_user_token")}`,
        ...config.headers,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
misbarInstanceV2.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_user_token")}`,
        ...config.headers,
        "X-Version": 2,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
misbarInstanceV3.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_user_token")}`,
        ...config.headers,
        "X-Version": 3,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
misbarInstanceV4.interceptors.request.use(
  async (config) => {
    try {
      config.headers = {
        authorization: `Bearer ${getLocalStorage("suhail_user_token")}`,
        ...config.headers,
        "X-Version": 4,
      };
      if (config.params) {
        config.params = cleanParams(config.params);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
